<div class="container-cliente-pedidos" #container>
    <div class="container-cliente-pedidos-header">
        <button type="button" class="btn btn-primary mr-2" (click)="insertPedido()" *ngIf="config?.canInsertPedido">
            <i class="fas fa-plus" aria-hidden="true"></i> Novo Pedido
        </button>

        <div class="btn-group">
            <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="d-none d-md-inline-block">Opções</span>
            </button>
            <div class="dropdown-menu">
                <a class="dropdown-item" (click)="openPedidosExcelListagemModal()">
                    <i class="far fa-file-excel"></i> Exportar para Excel
                </a>
            </div>
        </div>
    </div>

    <div class="container-cliente-pedidos-filter">
        <sgt-pedido-filter
            [filter]="filter"
            [isShowSegmentosClientesFilter]="false"
            [isShowClienteFilter]="false"
            [isShowRepresentantesFilter]="false"
            (filterInitialized)="onFilterInitialized()"
            (filterChange)="onFilterChange()">
        </sgt-pedido-filter>
    </div>

    <div class="container-cliente-pedidos-body">
        <sgt-pedido-pedido-list
            #list
            [filter]="filter">
        </sgt-pedido-pedido-list>
    </div>
</div>


<!-- Modal para exporta a listagem dos pedidos para Excel -->
<sgt-pedido-excel-listagem-modal
    #pedidoExcelListagemModal>
</sgt-pedido-excel-listagem-modal>
